import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useIsDesktop } from '../../mq/esm';
import { PlateDesktop } from './desktop/Component.desktop.js';
import { PlateMobile } from './mobile/Component.mobile.js';
import './components/base-plate/Component.js';
import 'react-merge-refs';
import 'classnames';
import '../../icon-button/esm';
import './warning-a716d657.js';
import 'detect-browser';
import '@alfalab/hooks';
import '@alfalab/icons-glyph/ChevronDownMIcon';
import '@alfalab/icons-glyph/CrossMIcon';
import './components/button-list/component.js';

var Plate = forwardRef(function (_a, ref) {
    var children = _a.children, breakpoint = _a.breakpoint, client = _a.client, _b = _a.defaultMatchMediaValue, defaultMatchMediaValue = _b === void 0 ? client === undefined ? undefined : client === 'desktop' : _b, restProps = __rest(_a, ["children", "breakpoint", "client", "defaultMatchMediaValue"]);
    var isDesktop = useIsDesktop(breakpoint, defaultMatchMediaValue);
    var Component = isDesktop ? PlateDesktop : PlateMobile;
    return (React.createElement(Component, __assign({ ref: ref }, restProps), children));
});
Plate.displayName = 'Plate';

export { Plate };
